import { civilities } from "../../static/types/commonTypes/individualType"
import PostalCodeField from "./PostalCodeField"
import useValidation from "../../hooks/useValidation"
import { useEffect } from "react"
import individualWithBirthNameValidationSchema from "../../utils/validation/individualWithBirthNameValidationSchema"
import { IndividualWithBirthNameType } from "../../static/types/commonTypes/individualWithBirthNameType"

type individualWithBirthNameProps = {
    checked: boolean,
    individual: IndividualWithBirthNameType,
    changeIndividual: ( partialIndividual: Partial<IndividualWithBirthNameType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function IndividualWithBirthName ({
    checked,
    individual,
    changeIndividual,
    onValidationChange
}: individualWithBirthNameProps ) {

    const { errors, isValid } = useValidation( individual, individualWithBirthNameValidationSchema )

    useEffect( () => {
        onValidationChange( isValid )
    }, [ isValid, onValidationChange ])

    return(
        <div className="container my-4">
            <div className="card-body">
                <div className="mb-3 row">
                    <label htmlFor="civility" className="col-sm-2 col-form-label">
                        Civilité <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-10">
                        <select
                            className={`form-control ${checked && errors.civility ? "is-invalid" : ""}`}
                            name="civility"
                            id="civility"
                            value={individual.civility}
                            onChange={(event) =>
                            changeIndividual({
                                civility: event.target.value as "Monsieur" | "Madame",
                            })
                            }
                        >
                            {civilities.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                            ))}
                        </select>
                    {checked && errors.civility && (
                        <div className="invalid-feedback">{errors.civility}</div>
                    )}
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="lastName" className="col-sm-2 col-form-label">
                        Nom <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-4">
                        <input
                            type="text"
                            name="lastName"
                            id="lastName"
                            className={`form-control ${checked && errors.lastName ? "is-invalid" : ""}`}
                            value={individual.lastName}
                            onChange={(event) =>
                        changeIndividual({ lastName: event.target.value })
                        }
                        />
                        {checked && errors.lastName && (
                            <div className="invalid-feedback">{errors.lastName}</div>
                        )}
                    </div>
                    <label htmlFor="firstName" className="col-sm-2 col-form-label">
                        Prénom <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-4">
                        <input
                            type="text"
                            name="firstName"
                            id="firstName"
                            className={`form-control ${checked && errors.firstName ? "is-invalid" : ""}`}
                            value={individual.firstName}
                            onChange={(event) =>
                            changeIndividual({ firstName: event.target.value })
                            }
                        />
                        {checked && errors.firstName && (
                            <div className="invalid-feedback">{errors.firstName}</div>
                        )}
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="address" className="col-sm-2 col-form-label">
                        Adresse <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-4">
                        <input
                            type="text"
                            name="address"
                            id="address"
                            className={`form-control ${checked && errors.address ? "is-invalid" : ""}`}
                            value={individual.address}
                            onChange={(event) =>
                            changeIndividual({ address: event.target.value })
                            }
                        />
                        {checked && errors.address && (
                            <div className="invalid-feedback">{errors.address}</div>
                        )}
                    </div>

                    <label htmlFor="additionalAddress" className="col-sm-2 col-form-label">
                        Adresse suite
                    </label>
                    <div className="col-sm-4">
                        <input
                            type="text"
                            name="additionalAddress"
                            id="additionalAddress"
                            className="form-control"
                            value={individual.additionalAddress}
                            onChange={(event) =>
                            changeIndividual({ additionalAddress: event.target.value })
                            }
                        />
                    </div>
                </div>
                <div className="mb-3 row">
                    <PostalCodeField
                    checked={checked}
                    onChange={changeIndividual}
                    postalCode={individual.postalCode}
                    errors={errors}
                    />
                    <label htmlFor="city" className="col-sm-2 col-form-label">
                        Ville <strong className="text-danger">*</strong>
                    </label>
                    <div className="col-sm-4">
                        <select
                            className={`form-control ${checked && errors.city ? "is-invalid" : ""}`}
                            name="city"
                            id="city"
                            value={individual.city}
                            onChange={(event) =>
                            changeIndividual({ city: event.target.value })
                            }
                        >
                            {individual.cities?.map((city, key) => (
                            <option key={key} value={city}>
                                {city}
                            </option>
                            ))}
                        </select>
                        {checked && errors.city && (
                            <div className="invalid-feedback">{errors.city}</div>
                        )}
                    </div>
                </div>
                <div className="mb-3 row">
                    <label htmlFor="birthName" className="col-sm-2 col-form-label">
                        Nom de naissance
                    </label>
                    <div className="col-sm-4">
                        <input
                            type="text"
                            name="birthName"
                            id="birthName"
                            className="form-control"
                            value={individual.birthName}
                            onChange={(event) =>
                            changeIndividual({ birthName: event.target.value })
                            }
                        />
                    </div>
                </div>
            </div>
        </div>

    )
}